import { getSubdomain } from "../utils/helper";
import { isAfricatv } from "./multiDomains";

export let config = {
  domain: "",
  lang: "",
  dir: "ltr",
  country: "xx",
  countryCode: 0,
};
config.domain = getSubdomain();

let url = window.location.origin.split(".")[0];

if (url.indexOf('za') >= 0) {
    config.lang = 'en';
    config.domain = 'za';
    config.countryCode = 27;
    config.country = 'za';
} else if (url.indexOf("plus") >= 0) {
    config.lang = "en";
    config.domain = "plus";
    config.countryCode = 27;
    config.country = "za";  
}
else if(url.indexOf('ch') >= 0){
    config.lang = 'de';
    config.domain = 'ch';
    config.countryCode = 41;
    config.country = 'ch'
}
else if(url.indexOf('gr') >= 0){
    config.lang = 'el'
    config.domain = 'gr'
    config.countryCode = '30';
    config.country = 'gr'
}
else if(url.indexOf('ng') >= 0){
    config.lang = 'en'
    config.domain = 'ng',
    config.countryCode = '234',
    config.country = 'ng'
}
else if (url.indexOf('watch') >= 0) {
    config.lang = 'en';     
    config.domain = 'watch'; 
    config.countryCode = '';
    config.country = 'xx';
}
else if (url.indexOf('me') >= 0){
    config.lang = 'en';
    config.domain = 'me';
    config.countryCode = '';
    config.country = 'me';
}
else if (url.indexOf('eg') >= 0){
    config.lang = 'en';
    config.domain = 'eg';
    config.countryCode = '20';
    config.country = 'eg';
}
else if (url.indexOf('ci') >= 0 ){
    config.lang = 'fr';
    config.domain = 'ci';
    config.countryCode = '225';
    config.country = 'ci'
}
else if (url.indexOf('sn') >= 0 ) {
    config.lang = 'fr';
    config.domain = 'sn';
    config.countryCode = '221';
    config.country = 'sn';
}
else if (url.indexOf('cd') >= 0) {
    config.lang = 'fr';
    config.domain = 'cd';
    config.countryCode = '243';
    config.country = 'cd';
}
else if (url.indexOf('bh') >= 0) {
    config.lang = 'ar';
    config.domain = 'bh';
    config.countryCode = '973';
    config.country = 'bh';
    config.dir = "rtl";
}
else if (url.indexOf('kw') >= 0) {
    config.lang = 'ar';
    config.domain = 'kw';
    config.countryCode = '965';
    config.country = 'kw';
    config.dir = "rtl";
}
else if (url.indexOf('fr') >= 0) {
    config.lang = 'fr';
    config.domain = 'fr';
    config.countryCode = '33';
    config.country = 'fr';
}
else if (url.indexOf('tn') >= 0) {
    config.lang = 'fr';
    config.domain = 'tn';
    config.countryCode = '216';
    config.country = 'tn';
}
else if (url.indexOf('cm') >= 0) {
    config.lang = 'fr';
    config.domain = 'cm';
    config.countryCode = '237';
    config.country = 'cm'
}
else if (url.indexOf('be') >= 0) {
    config.lang = (window.navigator.language && window.navigator.language.split('-')[0] === 'nl') ? 'be' : (window.navigator.language && window.navigator.language.split('-')[0] === 'de') ? 'de' : 'fr';
    config.domain = 'be';
    config.countryCode = '32';
    config.country = 'be';
}
else if (url.indexOf('vn') >= 0){
    config.lang = 'en';
    config.domain = 'vn';
    config.countryCode = '84';
    config.country = 'vn';
}
else if (url.indexOf('tr') >= 0){
    config.lang = 'tr';
    config.domain = 'tr';
    config.countryCode = '90';
    config.country = 'tr'
}
else if (url.indexOf('pt') >= 0){
    config.lang = 'pt';
    config.domain = 'pt';
    config.country = 'pt';
    config.countryCode = '351';
}

else if (url.indexOf('demo') >= 0) {
    config.lang = 'en';
    config.domain = 'demo';
    config.country = 'xx';
    config.countryCode = '';
}

else if (url.indexOf('no') >= 0 ) {
    config.lang = 'no';
    config.domain = 'no';
    config.country = 'no';
    config.countryCode = '47';
}
else if (url.indexOf('maxis') >= 0) {
    config.lang = 'en';
    config.domain = 'maxis';
    config.country = 'my';
    config.countryCode = '60';
}
else if (url.indexOf('iq') >= 0 ) {
    config.lang = 'ar';
    config.domain = 'iq';
    config.country = 'iq';
    config.dir='rtl'
    config.countryCode = '964';
}
else if (url.indexOf('rs') >= 0  ) {
    config.lang = 'cy';
    config.domain = 'rs';
    config.country = 'rs';
    config.countryCode = '381';
}
else if (url.indexOf('sa') >= 0 ) {
    config.lang = 'ar';
    config.domain = 'sa';
    config.country = 'sa';
    config.dir='rtl'
    config.countryCode = '966';
}
else if (url.indexOf('ee') >= 0) {
    config.lang = 'ee';
    config.domain = 'ee';
    config.country = 'ee';
    config.countryCode = '372';
}
else  if(url.indexOf('peru') >= 0 ) {
    config.lang = 'es';
    config.domain = 'peru';
    config.country = 'pe';
    config.countryCode = '51';
}
else if(url.indexOf('ae') >= 0) {
    config.lang = 'en';
    config.domain = 'ae';
    config.country = 'ae';
    config.countryCode = '971'
}
    else if (url.indexOf('lu') >= 0){
    config.lang = 'fr';
    config.domain = 'lu';
    config.countryCode = '352';
    config.country = 'lu';
}
else if(url.indexOf('id') >= 0) {
    config.lang = 'id';
    config.domain = 'id';
    config.country = 'id';
    config.countryCode = '62'
}
else if(url.indexOf('pl') >= 0) {
    config.lang = 'pl';
    config.domain = 'pl';
    config.country = 'pl';
    config.countryCode = '48'
}
else if(url.indexOf('th') >= 0) {
    config.lang = 'th';
    config.domain = 'th';
    config.country = 'th';
    config.countryCode = '66'
}
else if(url.indexOf('mx') >= 0 || url.indexOf("local") >= 0) {
    config.lang = 'es';
    config.domain = 'mx';
    config.country = 'mx';
    config.countryCode = '52'
}
else {
    config.lang = 'en';
    config.domain = 'demo';
    config.country = 'xx';
    config.countryCode = '';
}



// WEBPACK FOOTER //
// ./src/constants/domainConfig.js